import qs from 'qs';
import { v4 } from 'uuid';

import { CustomerTrackingDto } from 'common/api/autogenerated/client-area';

import { IncomeRemarketing, IncomeRemarketingEnum } from './types';

const remarketingRegExp = new RegExp(`Remarketing=(?!${Object.keys(IncomeRemarketingEnum).join('|')})`);

export const parseParams = (params = ''): IncomeRemarketing[] | undefined => {
  if (!params) return;

  if (params.includes('|||')) {
    const segments = params.split('|||');

    return segments.map((i) => {
      const segment = remarketingRegExp.test(i) ? i : i.replace('Remarketing=', '');
      return qs.parse(segment, { ignoreQueryPrefix: true });
    });
  }

  return undefined;
};

export const mapRemarketingToServer = (segments: IncomeRemarketing[] = []): CustomerTrackingDto[] => {
  if (!segments) return [];

  return segments.map((segment) => ({
    action: segment.action,
    asset: segment.asset,
    id: segment.id || v4(),
    remarketing: segment.Remarketing || `atag=${segment.atag}`,
    tag: segment.atag,
    timeStamp: segment.timestamp,
    utmCampaign: segment.utm_campaign,
    utmContent: segment.utm_content,
    utmMedium: segment.utm_medium,
    utmSource: segment.utm_source,
    utmTerm: segment.utm_term,
  }));
};
